import Input from "components/Elements/Inputv2";
import React, { FC } from "react";
import { SendingServiceSettingsProps } from "../SmsSettings";

const TwilioSettings: FC<SendingServiceSettingsProps> = ({
  formData,
  setFormData,
}) => {
  return (
    <div className="p-5 flex justify-center font-inter text-[14px] font-normal leading-[22px] text-[#111827]">
      <div className="max-w-[970px] w-full flex flex-col gap-5">
        <div className="bg-white p-5 flex flex-col gap-5">
          <div className="flex flex-col gap-[5px]">
            <div>Twilio account SID</div>
            <Input
              id="twilio-account-sid-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.smsAccountSid}
              onChange={(value) =>
                setFormData({ ...formData, smsAccountSid: value })
              }
              placeholder="Key number"
            />
          </div>

          <div className="flex flex-col gap-[5px]">
            <div>Twilio auth token</div>
            <Input
              id="twilio-auth-token-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.smsAuthToken}
              onChange={(value) =>
                setFormData({ ...formData, smsAuthToken: value })
              }
              placeholder="Auth Token"
            />
          </div>

          <div className="flex flex-col gap-[5px]">
            <div>SMS From </div>
            <Input
              id="twilio-auth-token-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.smsFrom}
              onChange={(value) => setFormData({ ...formData, smsFrom: value })}
              placeholder="SMS From"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwilioSettings;
